import { Paper } from '@mui/material';
import React from 'react';
import SubscriptionPriceWidget from '../../../common/PUHomepage/SubscriptionPriceWidget';
import PerformanceWidget from '../../../common/PUHomepage/PerformanceWidget';
import FooterV2 from '../../../common/FooterV2';

const DefaultPUWidget = () => {
    return <React.Fragment>
        <Paper
            elevation={3}
        >
            <SubscriptionPriceWidget />
        </Paper>
        <Paper
            elevation={3}
            style={{ marginTop: '12px' }}
        >
            <PerformanceWidget />
        </Paper>
        <FooterV2 />
    </React.Fragment>;
};

export default DefaultPUWidget;